var exports = {
  "W": "x4ddf2309--43b8ae--labels",
  "P": "x4ddf2309--43b8ae--label",
};

module.exports = exports;
